import React from "react";

import whatCrypto from "../../../images/what-crypto.png";
import whyBuild from "../../../images/why_built.png";
import visionImg from "../../../images/vision-img.jpg";
import { Container, Row, Col, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaRobot, FaChartLine } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const WhatCrypto = () => {
  const navigate = useNavigate();
  return (
    <>
      <section className="info-section ">
        <Container>
          <Row className="align-items-center">
            <Col lg={6}>
              <motion.div
                className="info-text"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                <h2 className="fw-bold mb-4 display-5">
                  Advanced Trading Solutions
                </h2>
                <p className="text-muted fs-6 mb-3">
                  Our platform offers a comprehensive trading solution combining
                  cryptocurrency and commodities markets. With our proven
                  scalping trading bot averaging 37% monthly returns and
                  institutional OTC access, we provide a unique opportunity for
                  both retail and institutional investors to maximize their
                  trading potential.
                </p>

                <div className="d-flex gap-3 mt-4">
                  <div className="crypto-icon">
                    <FaRobot />
                    <span>Trading Bot</span>
                  </div>
                  <div className="crypto-icon">
                    <FaChartLine />
                    <span>Commodities</span>
                  </div>
                </div>

                <Button
                  className="btn-polygon mt-4 fw-bold"
                  onClick={() => navigate("/kyc")}
                >
                  Explore Trading
                </Button>
              </motion.div>
            </Col>
            <Col lg={6}>
              <motion.div
                className="image-wrapper"
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                <img
                  src={whatCrypto}
                  alt="Understanding Cryptocurrency"
                  className="img-fluid rounded shadow"
                />
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Why We Built This */}
      <section className="info-section alt py-5">
        <Container>
          <Row className="align-items-center justify-content-between flex-lg-row-reverse">
            <Col lg={6}>
              <motion.div
                className="info-text"
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                <h2 className="fw-bold mb-4 display-6">Our Trading Strategy</h2>
                <p className="text-muted fs-6 mb-3">
                  Our platform specializes in scalping trading strategies,
                  leveraging advanced algorithms and institutional-grade
                  infrastructure to deliver consistent returns. After each
                  trading session, profits are automatically converted to USDT
                  (stablecoin) for secure storage and easy access.
                </p>

                <ul className="list-unstyled mt-3 mb-4 ps-0 mission-list">
                  <li className="position-relative ps-4 mb-2">
                    Proven 37% average monthly returns
                  </li>
                  <li className="position-relative ps-4 mb-2">
                    Automated risk management
                  </li>
                  <li className="position-relative ps-4 mb-2">
                    Institutional OTC pricing access
                  </li>
                  <li className="position-relative ps-4 mb-2">
                    Secure USDT conversion for profits
                  </li>
                </ul>
                <Button
                  className="btn-polygon mt-4 fw-bold"
                  onClick={() => navigate("/kyc")}
                >
                  Learn More
                </Button>
              </motion.div>
            </Col>
            <Col lg={5}>
              <motion.div
                className="image-wrapper"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                <img
                  src={whyBuild}
                  alt="Our Mission"
                  className="img-fluid rounded shadow"
                />
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Vision & Future */}
      <section className="info-section py-5">
        <Container>
          <Row className="align-items-center">
            <Col lg={6}>
              <motion.div
                className="info-text"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                <h2 className="fw-bold mb-4 display-6">
                  Vision for the Future
                </h2>
                <p className="muted fs-6  mb-3">
                  We envision a world where digital assets are seamlessly
                  integrated...
                </p>

                <ul className="list-unstyled mt-3 mb-4 ps-0 mission-list">
                  <li className="position-relative ps-4 mb-2">
                    Expand to new markets and regions
                  </li>
                  <li className="position-relative ps-4 mb-2">
                    Introduce innovative trading features
                  </li>
                  <li className="position-relative ps-4 mb-2">
                    Enhance security and performance
                  </li>
                </ul>
                <Button
                  className="btn-polygon mt-4 fw-bold"
                  onClick={() => navigate("/kyc")}
                >
                  Learn More
                </Button>
              </motion.div>
            </Col>
            <Col lg={6}>
              <motion.div
                className="image-wrapper"
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                <img
                  src={visionImg}
                  alt="Our Vision"
                  className="img-fluid rounded shadow"
                />
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default WhatCrypto;
